import http from "../http-common";

class DataService {
  loginUser(data, header) {
    return http.post("index/login", data, header);
  }
  otpverify(data, header) {
    return http.post("index/chkotp", data, header);
  }
  reqotp(data, header) {
    return http.post("index/reqotp", data, header);
  }
  forgotpass(data, header) {
    return http.post("index/forgotpass", data, header);
  }
  keyloginUser(data, header) {
    return http.post("index/keylogin", data, header);
  }

  regUser(data, header) {
    return http.post("index/reg", data, header);
  }

  Enquiry(data, header) {
    return http.post("index/enquiry", data, header);
  }

  // TEAM START

  addTeam(data, header) {
    return http.post("team/add", data, header);
  }

  editTeam(data, header) {
    return http.post("team/edit", data, header);
  }

  listTeam(data, header) {
    return http.post("team/list", data, header);
  }

  statusTeam(data, header) {
    return http.post("team/status", data, header);
  }

  deleteTeam(data, header) {
    return http.post("team/del", data, header);
  }
  setteamorder(data, header) {
    return http.post("team/setord", data, header);
  }

  // TEAM END

  // CATEGORY START

  addCategory(data, header) {
    return http.post("cat/add/?msc=5", data, header);
  }

  editCategory(data, header) {
    return http.post("cat/edit", data, header);
  }

  listCategory(data, header) {
    return http.post("cat/list", data, header);
  }

  deleteCategory(data, header) {
    return http.post("cat/del", data, header);
  }
  setcatorder(data, header) {
    return http.post("cat/setord", data, header);
  }

  // CATEGORY END

  // PLAYER START

  joinPlayer(data, header) {
    return http.post("joinauction/joinplayer", data, header);
  }
  getreceiptlist(data, header) {
    return http.get("auction/getreceipts", data, header);
  }

  addPlayer(data, header) {
    return http.post("player/add", data, header);
  }

  editPlayer(data, header) {
    return http.post("player/edit", data, header);
  }

  listPlayer(data, header) {
    return http.post("player/list", data, header);
  }

  statusPlayer(data, header) {
    return http.post("player/status", data, header);
  }

  deletePlayer(data, header) {
    return http.post("player/del", data, header);
  }

  // PLAYER END

  // AUCTION START

  addAuction(data, header) {
    // console.log('KKKKK');
    // console.log(header);
    // console.log('KKKKKE');
    return http.post("auction/add", data, header);
  }

  editAuction(data, header) {
    return http.post("auction/edit", data, header);
  }

  statusAuction(data, header) {
    return http.post("auction/status", data, header);
  }

  listAuction(data, header) {
    return http.post("auction/list", data, header);
  }

  deleteAuction(data, header) {
    return http.post("auction/del", data, header);
  }

  editProfile(data, header) {
    return http.post("auction/editprofile", data, header);
  }
  plrforminfo(data, header) {
    return http.post("auction/plrforminfo", data, header);
  }
  pltransfer(data, header) {
    return http.post("auction/transferp", data, header);
  }
  tmtransfer(data, header) {
    return http.post("auction/transfert", data, header);
  }
  addsponsor(data, header) {
    return http.post("img/splogo", data, header);
  }
  addbanner(data, header) {
    return http.post("img/bnr", data, header);
  }
  addfiles(data, header) {
    return http.post("img/updfile", data, header);
  }
  addfilesname(data, header) {
    return http.post("img/updfilename", data, header);
  }
  delfiles(data, header) {
    return http.post("img/delfile", data, header);
  }
  delspn(data, header) {
    return http.post("img/delspn", data, header);
  }
  delbnr(data, header) {
    return http.post("img/delbnr", data, header);
  }

  updatePassword(data, header) {
    return http.post("auction/updpass", data, header);
  }

  JoinauctionCode(data, header) {
    return http.post("joinauction/codedetail", data, header);
  }
  JoinauctionCode2(data, header) {
    return http.post("joinauction/joinact", data, header);
  }

  getJoinAuction(data, header) {
    return http.post("joinauction/list", data, header);
  }

  Joinauction(data, header) {
    return http.post("joinauction/joinplayer", data, header);
  }
  settimer(data, header) {
    return http.post("auction/setting", data, header);
  }
  aucdetail(data, header) {
    return http.post("auction/detail", data, header);
  }
  updtrigger(data, header) {
    return http.post("auction/updtrigger", data, header);
  }
  setbooster(data, header) {
    return http.post("auction/updbooster", data, header);
  }
  setbidincr(data, header) {
    return http.post("auction/updbidincr", data, header);
  }
  bglist(data, header) {
    return http.post("img/bglist", data, header);
  }
  plrimport(data, header) {
    return http.post("/plrimport", data, header);
  }
  setbg(data, header) {
    return http.post("img/choosefl", data, header);
  }
  setbg(data, header) {
    return http.post("img/choosefl", data, header);
  }
  setbg(data, header) {
    return http.post("img/choosefl", data, header);
  }
  setfirework(data, header) {
    return http.post("auction/setting", data, header);
  }
  setmytheme(data, header) {
    return http.post("auction/updtheme", data, header);
  }
  setovtheme(data, header) {
    return http.post("auction/updovtheme", data, header);
  }
  delbooster(data, header) {
    return http.post("auction/delbooster", data, header);
  }
  delincrpoint(data, header) {
    return http.post("auction/delbidincr", data, header);
  }
  setplrform(data, header) {
    return http.post("auction/plrform", data, header);
  }
  listReceipts(data, header) {
    return http.post("msc/getreceiptlist", data, header);
  }
  removeQrImage(data, header) {
    return http.post("auction/removeqr", data, header);
  }
  gettransferphotosdata(data, header) {
    return http.post("msc/gettransferphotosdata", data, header);
  }

  todayAuction(data, header) {
    return http.post("index/alist?today=1", data, header);
  }

  upcomingAuction(data, header) {
    return http.post("index/alist?upcoming=1", data, header);
  }
  addPlayersToCategory(data, header) {
    return http.post("msc/pltocat", data, header);
  }
  saveLimit(data, headers) {
    return http.post("auction/plrformlimit", data, headers);
  }
  getLimit(data, hdr) {
  return http.post("auction/plrforminfo", data, hdr);
}


  // AUCTION END editprofile
}

export default new DataService();
